import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import Paper from '@modul-connect/shared/components/atoms/paper'
import { ReactComponent as InfoIcon } from '@modul-connect/shared/img/info.svg'
import { ReactComponent as DeleteIcon } from '@modul-connect/shared/img/delete_icon.svg'
import { ReactComponent as CheckMarkIcon } from '@modul-connect/shared/img/checkmark.svg'
import { ReactComponent as CancelEditIcon } from '@modul-connect/shared/img/cancel_edit.svg'
import View from '@modul-connect/shared/components/atoms/view'
import TextField from '@modul-connect/shared/components/molecules/textField'
import { styles as textStyles } from '@modul-connect/shared/components/atoms/text/text'
import { ClickableWrapper } from '@modul-connect/shared/components/atoms/clickableWrapper'
import { addToolBrand, addToolCategories, addToolCategory, addToolEquipmentName, editToolBrand, editToolCategory, editToolEquipmentName, fetchOrganisationToolConfig, removeToolBrand, removeToolCategory, removeToolEquipmentName, toggleCustomBrands, toggleCustomCategories, toggleCustomEquipmentNames } from '../../../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'
import { BubbleLoadingWidget } from '@modul-connect/shared/components/molecules/bubbleLoadingWidget/bubbleLoadingWIdget'
import { Modal, Tooltip } from '@mui/material'
import { fetchAssetTrackers } from '../../../../../state/actions/vehicles'
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import { MissingServiceAllert } from '../../../reportPage.v2'
import { margin } from '@mui/system'
import { getCategories, getCategoriesForDropdown } from '../../../../../utils/assets'
import { fetchAssetCategories } from '../../../../../state/actions/assets'

const ICONS = [
  'https://storageaccountcloud912e.blob.core.windows.net/assets/Lathes.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/Chainsaw.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/Nail_Gun.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/Constructor_lamp_1.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/Drill.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-calibration-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-charging-equipment.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-cleaning-supplies.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-cordless-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-cutting-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-fasteners.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-hand-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-inspection-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-ladders-equipment.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-measuring-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-plumbing-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-power-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-riveting-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-safety-equipment.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-screwdriver.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-specialty-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-storage.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/icon-vehicle-tools.svg',
  'https://storageaccountcloud912e.blob.core.windows.net/assets/Other.svg'
]

const ToggleSwitch = ({ checked, onChange }) => (
  <View
    onClick={() => onChange(!checked)}
    style={{
      width: '32px',
      height: '18px',
      backgroundColor: checked ? '#4caf50' : '#ccc',
      borderRadius: '12px',
      position: 'relative',
      cursor: 'pointer',
      transition: 'background-color 0.3s',
      flexShrink: 0 
    }}
  >
    <View style={{
      width: '14px', 
      height: '14px',
      backgroundColor: 'white',
      borderRadius: '50%',
      position: 'absolute',
      top: '2px', 
      left: checked ? '16px' : '2px', 
      transition: 'left 0.3s',
      boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
    }} />
  </View>
)

const DeleteModal = ({ item, organisationIds, assets, type, onDelete, open, onClose }) => {
  const name = item?.name ?? item
  const typeFormatted = type === 'categories' ? 'category' : type === 'brands' ? 'brand' : 'equipment name'
  const assetsWithType = useMemo(() => {
    if (!open || !Array.isArray(assets)) return 0

    if (type === 'categories') {
      return assets.filter(a => a?.category === item?.name && organisationIds.includes(a?.organisationId)).length
    } else if (type === 'brands') {
      return assets.filter(a => a?.brand === item && organisationIds.includes(a?.organisationId)).length
    } else if (type === 'equipment') {
      return assets.filter(a => a?.name === item && organisationIds.includes(a?.organisationId)).length
    }
    
    return 0
  }, [open, assets, item, type, organisationIds])
  return (
    <Modal open={open} onClose={() => onClose()}>
      <View style={{ 
        position: 'absolute',
        top: '50%', 
        left: '50%', 
        width: '530px', 
        transform: 'translate(-50%, -50%)', 
        padding: '12px 24px 24px 24px', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '26px', 
        backgroundColor: '#FFFFFF',
        borderRadius: '4px',
        boxShadow: '0px 4px 10px 0px #00000014',
        alignItems: 'center',
        fontSize: '16px',
        fontFamily: 'Inter',
        fontWeight: '400'
      }}>
        <View style={{ display: 'flex', gap: '12px', paddingTop: '32px' }}>
          <span>Do you want to delete </span>
          <DeleteIcon/>
        </View>
        <View>
          {name}
        </View>
        <View style={{ fontStyle: 'italic', textAlign: 'center', borderBottom: '1px solid #e9e9e9', paddingBottom: '26px' }}>
          {assetsWithType > 0 && (
            <>
              <strong>Warning:</strong> {assetsWithType} asset(s) have this {typeFormatted}. They will still have this {typeFormatted} after deletion.{' '}
            </>
          )}
          Are you sure you want to proceed?
        </View>
        <View style={{ display: 'flex', gap: '10px' }}>
          <Button noBg border onClick={onDelete}>Delete <DeleteIcon/></Button>
          <Button noBg border onClick={onClose}>Cancel</Button>
        </View>
      </View>
    </Modal>
  )
}

const WarningModal = ({ description, open, onClose }) => {
  return (
    <Modal open={open} onClose={() => onClose()}>
      <View style={{ 
        position: 'absolute',
        top: '50%', 
        left: '50%', 
        width: '400px', 
        transform: 'translate(-50%, -50%)', 
        padding: '12px 24px 24px 24px', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '26px', 
        backgroundColor: '#FFFFFF',
        borderRadius: '4px',
        boxShadow: '0px 4px 10px 0px #00000014',
        alignItems: 'center',
        fontSize: '16px',
        fontFamily: 'Inter',
        fontWeight: '400'
      }}>
        <View style={{ textAlign: 'center', paddingTop: '26px' }}>
          {description}
        </View>
        <View style={{ display: 'flex', gap: '10px' }}>
          <Button style={{ border: '1px solid #404040', padding: '8px 20px 8px 20px', color: '#404040' }} onClick={onClose}>Ok</Button>
        </View>
      </View>
    </Modal>
  )
}

const SelectIconModal = ({ selectedIcon, onSelectIcon, open, onClose, onSave }) => {
  return (
    <Modal open={open} onClose={() => onClose()}>
      <View style={{ 
        position: 'absolute',
        top: '50%', 
        left: '50%', 
        width: '530px', 
        transform: 'translate(-50%, -50%)', 
        padding: '12px 24px 24px 24px', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '26px', 
        backgroundColor: '#FFFFFF',
        borderRadius: '4px',
        boxShadow: '0px 4px 10px 0px #00000014',
        alignItems: 'center',
        fontSize: '16px',
        fontFamily: 'Inter',
        fontWeight: '400'
      }}>
        <View style={{ display: 'flex', gap: '8px', width: '482px', flexWrap: 'wrap', textAlign: 'center', paddingTop: '26px', paddingBottom: '16px', borderBottom: '1px solid #e9e9e9' }}>
          {ICONS.map((icon, idx) => (
            <img 
              key={idx} 
              src={icon} 
              onClick={() => onSelectIcon(icon)}
              style={{ 
                width: '32px', height: '32px', cursor: 'pointer', 
                padding: '1px',
                border: selectedIcon === icon ? '2px solid #488484' : '1px solid transparent',
                borderRadius: '4px'
              }} 
            />
          ))}
        </View>
        <View style={{ display: 'flex', gap: '10px' }}>
          <Button noBg border onClick={onClose}>Cancel</Button>
          <Button onClick={onSave}>Select</Button>
        </View>
      </View>
    </Modal>
  )
}

export const CustomInfoTooltip = ({ tooltipContent, children }) => {
  return (
    <Tooltip
      placement="right-start" 
      title={
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '12px',
          fontSize: '14px',
          lineHeight: '1.5',
          fontWeight: '500',
          color: '#1a1a1a',
          fontFamily: 'Inter'
        }}>
          <div style={{ flexShrink: 0, marginTop: '4px', display: 'flex' }}>
            <InfoIcon />
          </div>
          <div>
            {tooltipContent}
          </div>
        </div>
      }
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: '#ffffff',
            border: '1px solid #dcdcdc',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            padding: '24px',
            maxWidth: '409px'
          }
        }
      }}
    >
      <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
        {children}
      </span>
    </Tooltip>
  )
}

const OrganisationToolConfiguration = ({
  organisationId,
  fetchOrganisationToolConfig,
  organisationToolConfig,
  addToolCategories,
  addToolCategory,
  addToolBrand,
  addToolEquipmentName,
  removeToolCategory,
  removeToolBrand,
  removeToolEquipmentName,
  editToolCategory,
  editToolBrand,
  editToolEquipmentName,
  toggleCustomCategories,
  toggleCustomBrands,
  toggleCustomEquipmentNames,
  loading,
  fetchAssetTrackers,
  fetchAssetCategories,
  assets,
  subtrees,
  disabled
}) => {

  const [categories, setCategories] = useState([])
  const [brands, setBrands] = useState([])
  const [equipmentNames, setEquipmentNames] = useState([])

  const [allowCustomCategories, setAllowCustomCategories] = useState(true)
  const [allowCustomBrands, setAllowCustomBrands] = useState(true)
  const [allowCustomEquipment, setAllowCustomEquipment] = useState(true)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [deleteItem, setDeleteItem] = useState(null)
  const [deleteType, setDeleteType] = useState(null)

  const [openWarningModal, setOpenWarningModal] = useState(false)
  const [warningDescription, setWarningDescription] = useState('')

  const [inputIcon, setInputIcon] = useState(ICONS[0] || '')
  const [openSelectIconModal, setOpenSelectIconModal] = useState(false)
  const [inputCategory, setInputCategory] = useState('')

  const { getAccessTokenSilently } = useAuth0()

  const isLoading = loading?.organisationToolConfig === 'loading'

  const childrenIds = subtrees?.subtrees.find(s => s?.uuid === organisationId)?.children?.map(c => c?.uuid) || []
  const organisationIds = [...childrenIds, organisationId]

  const handleAddCategoryClick = () => {
    if (inputCategory.trim() !== '') {
      handleAdd('categories', { name: inputCategory, iconUrl: inputIcon })
      setInputCategory('')
    }
  }

  useEffect(() => {
    getAccessTokenSilently()
      .then(token => {
        fetchOrganisationToolConfig(token, organisationId)
        fetchAssetTrackers(token)
        fetchAssetCategories(token)
      })
  }, [organisationId])

  useEffect(() => {
    if (organisationToolConfig) {
      setCategories(organisationToolConfig.categories)
      setBrands(organisationToolConfig.brands)
      setEquipmentNames(organisationToolConfig.equipmentNames)
      setAllowCustomBrands(organisationToolConfig.customBrands)
      setAllowCustomCategories(organisationToolConfig.customCategories)
      setAllowCustomEquipment(organisationToolConfig.customEquipmentNames)
    }

  }, [organisationToolConfig])

  const handleAdd = (type, value) => {
    if (type === 'categories') {

      if (categories.some(c => c.name === value.name)) {
        setWarningDescription(`Category '${value.name}' already exists`)
        setOpenWarningModal(true)
        return
      }

      if (value)
        getAccessTokenSilently()
          .then(token => {
            addToolCategory(token, organisationId, value?.name, value?.iconUrl)
          })
    } 
    if (type === 'brands') {

      if (brands.some(b => b === value)) {
        setWarningDescription(`Brand '${value}' already exists`)
        setOpenWarningModal(true)
        return
      }

      if (value)
        getAccessTokenSilently()
          .then(token => {
            addToolBrand(token, organisationId, value)
          })
    }
    if (type === 'equipment') {

      if (equipmentNames.some(e => e === value)) {
        setWarningDescription(`Equipment name '${value}' already exists`)
        setOpenWarningModal(true)
        return
      }

      if (value)
        getAccessTokenSilently()
          .then(token => {
            addToolEquipmentName(token, organisationId, value)
          })
    }
  }

  const onDelete = (type, item) => {
    if (type === 'categories') { 
      if (item)
        getAccessTokenSilently()
          .then(token => {
            removeToolCategory(token, organisationId, item?.name, item?.iconUrl)
          })
    }
    if (type === 'brands') {
      if (item)
        getAccessTokenSilently()
          .then(token => {
            removeToolBrand(token, organisationId, item)
          })
    }
    if (type === 'equipment') {
      if (item)
        getAccessTokenSilently()
          .then(token => {
            removeToolEquipmentName(token, organisationId, item)
          })
    }
  }

  const handleRemove = (type, item) => {
    setDeleteItem(item)
    setDeleteType(type)
    setOpenDeleteModal(true)
  }

  const handleEdit = (type, oldItem, newItem) => {

    if (type === 'categories') {

      if (categories.some(c => c.name === newItem.name)) {
        setWarningDescription(`Category '${newItem.name}' already exists`)
        setOpenWarningModal(true)
        return
      }

      if (oldItem && newItem)
        getAccessTokenSilently()
          .then(token => {
            editToolCategory(token, organisationId, oldItem.name, newItem.name, oldItem.iconUrl, newItem.iconUrl)
          })
    }
    if (type === 'brands') {

      if (brands.some(b => b === newItem)) {
        setWarningDescription(`Brand '${newItem}' already exists`)
        setOpenWarningModal(true)
        return
      }

      if (oldItem && newItem)
        getAccessTokenSilently()
          .then(token => {
            editToolBrand(token, organisationId, oldItem, newItem)
          })
    }
    if (type === 'equipment') {

      if (equipmentNames.some(e => e === newItem)) {
        setWarningDescription(`Equipment name '${newItem}' already exists`)
        setOpenWarningModal(true)
        return
      }

      if (oldItem && newItem)
        getAccessTokenSilently()
          .then(token => {
            editToolEquipmentName(token, organisationId, oldItem, newItem)
          })
    }
  }

  const onAllowCustomCategories = (isEnabled) => {
    getAccessTokenSilently()
      .then(token => {
        toggleCustomCategories(token, organisationId, isEnabled)
      })
  }

  const onAllowCustomBrands = (isEnabled) => {
    getAccessTokenSilently()
      .then(token => {
        toggleCustomBrands(token, organisationId, isEnabled)
      })
  }

  const onAllowCustomEquipmentNames = (isEnabled) => {
    getAccessTokenSilently()
      .then(token => {
        toggleCustomEquipmentNames(token, organisationId, isEnabled)
      })
  }

  return (
    <Paper 
      title="Add your own categories, brands, and equipment names" 
      extend={{ 
        boxShadow: '0px 4px 10px 0px #00000014', 
        height: 'calc(100vh - 120px)', 
        marginBottom: '-150px', 
        display: 'flex', 
        flexDirection: 'column',
        boxSizing: 'border-box', 
        overflow: 'hidden',
        paddingBottom: '0px'       
      }}
      extendChildContainer={{
        flex: 1,
        minHeight: 0,
        paddingBottom: '24px',
        alignItems: 'stretch'
      }}
    >
      {disabled ? (
        <MissingServiceAllert top={'0'} extend={{ maxHeight: '100px' }}/>
      ) : 
        isLoading ? (
          <BubbleLoadingWidget/>
        ) : (
          <View style={{ display: 'flex', flexDirection: 'row', gap: '32px', width: '100%', minHeight: '100%', alignItems: 'stretch', boxSizing: 'border-box' }}>
            
            <ToolCategoriesConfigurationPanel 
              title="categories" 
              type="Category" 
              items={categories}
              customAllowed={allowCustomCategories}
              onAllowCustom={onAllowCustomCategories}
              onAdd={(val) => handleAdd('categories', val)} 
              onRemove={(val) => handleRemove('categories', val)} 
              onEdit={(oldItem, newItem) => handleEdit('categories', oldItem, newItem)}
              setOpenSelectIconModal={(val) => setOpenSelectIconModal(val)}
              setInputValue={(val) => setInputCategory(val)} 
              inputValue={inputCategory}
            />

            <ToolConfigurationPanel 
              title="brands" 
              type="Brand" 
              items={brands}
              customAllowed={allowCustomBrands}
              onAllowCustom={onAllowCustomBrands}
              onAdd={(val) => handleAdd('brands', val)} 
              onRemove={(val) => handleRemove('brands', val)} 
              onEdit={(oldVal, newVal) => handleEdit('brands', oldVal, newVal)}
            />

            <ToolConfigurationPanel 
              title="equipment names" 
              type="Equipment name" 
              items={equipmentNames}
              customAllowed={allowCustomEquipment}
              onAllowCustom={onAllowCustomEquipmentNames}
              onAdd={(val) => handleAdd('equipment', val)} 
              onRemove={(val) => handleRemove('equipment', val)} 
              onEdit={(oldVal, newVal) => handleEdit('equipment', oldVal, newVal)}
            />

          </View>
        )}
      <DeleteModal 
        item={deleteItem} 
        type={deleteType} 
        organisationIds={organisationIds}
        assets={assets}
        onDelete={() => {onDelete(deleteType, deleteItem); setOpenDeleteModal(false)}} 
        open={openDeleteModal} 
        onClose={() => setOpenDeleteModal(false)}/>
      <WarningModal 
        description={warningDescription}
        open={openWarningModal} 
        onClose={() => setOpenWarningModal(false)}/>
      <SelectIconModal
        open={openSelectIconModal}
        onClose={() => setOpenSelectIconModal(false)}
        selectedIcon={inputIcon}
        onSelectIcon={setInputIcon}
        onSave={() => {
          handleAddCategoryClick()
          setOpenSelectIconModal(false)
        }}
      />
    </Paper>
  )
}

const AddButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{ padding: '0 16px', border: 'none', background: 'transparent', color: '#1744E2', fontWeight: '500', cursor: 'pointer', fontSize: '16px' }}
    >
      + Add
    </button>
  )
}

const ToolConfigurationPanel = ({ title, type, items, customAllowed, onAllowCustom, onAdd, onRemove, onEdit }) => {

  const [inputValue, setInputValue] = useState('')

  const handleAddClick = () => {
    if (inputValue.trim() !== '') {
      onAdd(inputValue) 
      setInputValue('')
    }
  }

  return (
    <div style={{ flex: 1, minWidth: 0, backgroundColor: '#ffffff', border: '1px solid #f0f0f0', borderRadius: '8px', padding: '24px', boxShadow: '0px 4px 10px 0px #00000014', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>

      <View style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px', width: '100%', height: '50px' }}>
          <View style={{ fontWeight: '700', fontSize: '16px', letterSpacing: '4%' }}>
            {title.toUpperCase()}
          </View>
          
          <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            
            <View style={{ fontWeight: '700', fontSize: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
              Allow custom {title} 
              <CustomInfoTooltip 
                tooltipContent={
                  <span>
                    When enabled, users can either input a <strong>completely bespoke {type?.replace(' name', '')?.toLowerCase()} name</strong> or select an option from both the default and custom-created lists.
                  </span>
                }
              >
                <InfoIcon />
              </CustomInfoTooltip>
            </View>

            <ToggleSwitch checked={customAllowed} onChange={onAllowCustom} />
            
          </View>
        </View>

        <View style={{ fontSize: '12px', color: '#606060', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px', letterSpacing: '2%' }}>
          ADD PREDEFINED {title}
          <CustomInfoTooltip 
            tooltipContent={
              <span>
                Create {type?.toLowerCase() + 's'} to help your fleet organise tools and assets.
              </span>
            }
          >
            <InfoIcon style={{ width: '11px', height: '11px' }}/>
          </CustomInfoTooltip>
        </View>
      </View>


      <View>
        <TextField
          placeholder={`Add ${type}`}
          variant={'outlined'}

          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          
          extend={{ 
            color: textStyles.inputText.color, 
            paddingRight: '70px', 
            boxSizing: 'border-box',
            border: '1px solid #CACACA',
            backgroundColor: 'none',
            ...(!inputValue ? { fontStyle: 'italic' } : {})
          }} 
          
          button={<AddButton onClick={handleAddClick} />}
          buttonExtend={{ top: 17.5, right: 0 }}
        />
      </View>

      <div className='always-scroll' style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflowY: 'auto', marginTop: '16px', paddingRight: '4px' }}>
        {items && items.map((item, index) => (
          <ToolListItem key={index} item={item} onRemove={onRemove} onEdit={onEdit} />
        ))}
      </div>
    </div>
  )
}

const ToolCategoriesConfigurationPanel = ({ title, type, items, onRemove, onEdit, inputValue, setInputValue, setOpenSelectIconModal }) => {
  return (
    <div style={{ flex: 1, minWidth: 0, backgroundColor: '#ffffff', border: '1px solid #f0f0f0', borderRadius: '8px', padding: '24px', boxShadow: '0px 4px 10px 0px #00000014', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>

      <View style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        <View style={{ fontWeight: '700', fontSize: '16px', height: '50px', letterSpacing: '4%' }}>
          {title.toUpperCase()}
        </View>

        <View style={{ fontSize: '12px', color: '#606060', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px', letterSpacing: '2%' }}>
          ADD PREDEFINED {title}
          <CustomInfoTooltip 
            tooltipContent={
              <span>
                Create categories to help your fleet organise tools and assets.
              </span>
            }
          >
            <InfoIcon />
          </CustomInfoTooltip>
        </View>
      </View>

 
      <View style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
        <TextField
          placeholder={`${type}`}
          variant={'outlined'}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          extend={{ 
            color: textStyles.inputText.color, 
            paddingRight: '70px', 
            boxSizing: 'border-box',
            border: '1px solid #CACACA',
            backgroundColor: 'none',
            ...(!inputValue ? { fontStyle: 'italic' } : {})
          }} 
          button={<AddButton onClick={() => setOpenSelectIconModal(true)} />}
          buttonExtend={{ top: 17.5, right: 0 }}
        />
      </View>
      
      <div className='always-scroll' style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflowY: 'auto', marginTop: '16px', paddingRight: '4px' }}>
        {items && items.map((item, index) => (
          <CategoryListItem 
            key={index} 
            item={item} 
            onRemove={onRemove} 
            onEdit={onEdit} 
          />
        ))}
      </div>
    
    </div>
  )
}

const CategoryListItem = ({ item, onRemove, onEdit }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editName, setEditName] = useState(item?.name || '')
  const [editIcon, setEditIcon] = useState(item?.iconUrl || '')

  const handleSave = () => {
    if (editName.trim() !== '') {
      onEdit(item, { name: editName, iconUrl: editIcon })
      setIsEditing(false)
    }
  }

  const handleCancel = () => {
    setEditName(item?.name || '')
    setEditIcon(item?.iconUrl || '')
    setIsEditing(false)
  }

  if (isEditing) { // Unused
    return (
      <div style={{ display: 'flex', flexDirection: 'column', padding: '12px 0', borderBottom: '1px solid #f0f0f0', gap: '8px' }}>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {ICONS.map((icon, idx) => (
            <img 
              key={idx} 
              src={icon} 
              onClick={() => setEditIcon(icon)}
              style={{ 
                width: '28px', height: '28px', cursor: 'pointer', 
                padding: '1px',
                border: editIcon === icon ? '2px solid #488484' : '1px solid transparent',
                borderRadius: '4px'
              }} 
            />
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
          <input 
            type="text" 
            value={editName} 
            onChange={(e) => setEditName(e.target.value)}
            style={{ flex: 1, padding: '8px', border: '1px solid #CACACA', borderRadius: '4px', outline: 'none' }}
          />
          <div style={{ display: 'flex', gap: '8px' }}>
            <ClickableWrapper onClick={() => handleSave()}><CheckMarkIcon/></ClickableWrapper>
            <ClickableWrapper onClick={() => handleCancel()}><CancelEditIcon/></ClickableWrapper>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0 8px', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {item?.iconUrl ? (
          <img src={item.iconUrl} alt={item.name} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
        ) : (
          <div style={{ width: '24px', height: '24px', backgroundColor: '#e0e0e0', borderRadius: '4px' }} />
        )}
        <span style={{ fontSize: '14px', color: '#333' }}>{item?.name}</span>
      </div>
      <div style={{ display: 'flex', gap: '12px', color: '#666' }}>
        <ClickableWrapper onClick={() => onRemove(item)}><DeleteIcon/></ClickableWrapper>
        {/*<ClickableWrapper onClick={() => setIsEditing(true)}><EditIcon/></ClickableWrapper>*/}
      </div>
    </div>
  )
}

const ToolListItem = ({ item, onRemove, onEdit }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editValue, setEditValue] = useState(item)

  const handleSave = () => {
    if (editValue.trim() !== '') {
      onEdit(item, editValue)
      setIsEditing(false)
    }
  }

  const handleCancel = () => {
    setEditValue(item)
    setIsEditing(false)
  }

  if (isEditing) { // Unused
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: 'px solid #f0f0f0', gap: '12px' }}>
        <input 
          type="text" 
          value={editValue} 
          onChange={(e) => setEditValue(e.target.value)}
          style={{ flex: 1, padding: '8px', border: '1px solid #CACACA', borderRadius: '4px', outline: 'none' }}
        />
        <div style={{ display: 'flex', gap: '8px' }}>
          <ClickableWrapper onClick={() => handleSave()}><CheckMarkIcon/></ClickableWrapper>
          <ClickableWrapper onClick={() => handleCancel()}><CancelEditIcon/></ClickableWrapper>
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
      <span style={{ fontSize: '14px', color: '#333' }}>{item}</span>
      <div style={{ display: 'flex', gap: '12px', color: '#666' }}>
        <ClickableWrapper onClick={() => onRemove(item)}><DeleteIcon/></ClickableWrapper>
        {/*<ClickableWrapper onClick={() => setIsEditing(true)}><EditIcon/></ClickableWrapper>*/} 
      </div>
    </div>
  )
}

const mapStateToProps = (props) => props

const mapDispatchToProps = (dispatch) => ({
  fetchOrganisationToolConfig: (accessToken, orgId) => dispatch(fetchOrganisationToolConfig(accessToken, orgId)),
  addToolCategory: (accessToken, orgId, category, iconUrl) => dispatch(addToolCategory(accessToken, orgId, category, iconUrl)),
  addToolBrand: (accessToken, orgId, brand) => dispatch(addToolBrand(accessToken, orgId, brand)),
  addToolEquipmentName: (accessToken, orgId, equipmentName) => dispatch(addToolEquipmentName(accessToken, orgId, equipmentName)),
  removeToolCategory: (accessToken, orgId, category, iconUrl) => dispatch(removeToolCategory(accessToken, orgId, category, iconUrl)),
  removeToolBrand: (accessToken, orgId, brand) => dispatch(removeToolBrand(accessToken, orgId, brand)),
  removeToolEquipmentName: (accessToken, orgId, equipmentName) => dispatch(removeToolEquipmentName(accessToken, orgId, equipmentName)),
  editToolCategory: (accessToken, orgId, oldCategory, newCategory, oldIconUrl, newIconUrl) => dispatch(editToolCategory(accessToken, orgId, oldCategory, newCategory, oldIconUrl, newIconUrl)),
  editToolBrand: (accessToken, orgId, oldBrand, newBrand) => dispatch(editToolBrand(accessToken, orgId, oldBrand, newBrand)),
  editToolEquipmentName: (accessToken, orgId, oldEquipmentName, newEquipmentName) => dispatch(editToolEquipmentName(accessToken, orgId, oldEquipmentName, newEquipmentName)),
  toggleCustomCategories: (accessToken, orgId, isEnabled) => dispatch(toggleCustomCategories(accessToken, orgId, isEnabled)),
  toggleCustomBrands: (accessToken, orgId, isEnabled) => dispatch(toggleCustomBrands(accessToken, orgId, isEnabled)),
  toggleCustomEquipmentNames: (accessToken, orgId, isEnabled) => dispatch(toggleCustomEquipmentNames(accessToken, orgId, isEnabled)),
  fetchAssetTrackers: (accessToken) => dispatch(fetchAssetTrackers(accessToken, false)),
  fetchAssetCategories: (accessToken) => dispatch(fetchAssetCategories(accessToken))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganisationToolConfiguration)